<template>
  <section class="section">
    <div class="container">
      <h1 class="title is-1">Manage</h1>
      <div v-if="isLoadingClublinks">
        <p>Loading clublinks</p>
      </div>
      <div v-else-if="message.length > 0">
        <p>{{message}}</p>
      </div>
      <div class="columns">
        <div class="column is-12">
          <b-button type="is-primary" size="is-large" class="is-fullwidth" @click="create" :disabled="quotaReached">Create ({{clublinks.length}}/{{clublinksLimit}})</b-button>
        </div>
      </div>
      <ul class="clublink-list">
        <li class="box" v-for="clublink in clublinks" :key="clublink.id">
          <div class="columns">
            <div class="column is-12">
              <h4 class="title is-4">{{clublink.name}}</h4>
            </div>
          </div>
          <div class="columns">
            <div class="column is-12">
              <div class="field has-addons">
                <div class="control is-expanded">
                  <input class="input" :id="clublink.id" type="text" :value="formatLink(clublink)" @click="select" readonly />
                </div>
                <div class="control">
                  <input type="button" value="Copy" class="copy-btn button is-info" :clublink-id="clublink.id" />
                </div>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column is-6">
              <b-button type="is-primary" class="is-fullwidth" outlined @click="edit(clublink)">Edit</b-button>
            </div>
            <div class="column is-6">
              <b-button type="is-danger" class="is-fullwidth" outlined @click="remove(clublink)">Delete</b-button>
            </div>
          </div>
        </li>
      </ul>
      <div class="columns" v-if="clublinks.length > 0">
        <div class="column is-12">
          <b-button type="is-primary" size="is-large" class="is-fullwidth" @click="create" :disabled="quotaReached">Create ({{clublinks.length}}/{{clublinksLimit}})</b-button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Clipboard from 'clipboard'

import { firestore } from '@/firebase.js'
import { CLUBLINKS_LIMIT, FUNCTIONS_URL, routes } from '@/constants.js'

let clipboard

export default {
  name: 'manage',
  data () {
    return {
      message: '',
      clublinksLimit: CLUBLINKS_LIMIT
    }
  },
  computed: {
    clublinks () {
      return this.$store.state.clublinks
    },
    isLoadingClublinks () {
      return this.$store.state.isLoadingClublinks
    },
    quotaReached () {
      return this.clublinks.length >= this.clublinksLimit
    }
  },
  methods: {
    select (event) {
      event.target.select()
    },
    remove (clublink) {
      this.message = ''
      const confirmRemove = window.confirm(`Confirm  deletion of "${clublink.name}"`)
      if (confirmRemove) {
        firestore.collection('clublinks')
          .doc(clublink.id)
          .delete()
          .then(() => {
            this.message = `"${clublink.name}" was successfully deleted.`
          }).catch((err) => {
            this.message = `"${clublink.name}" was not deleted. ${err.message}`
          })
      }
    },
    edit (clublink) {
      this.$router.push({ name: routes.edit, params: { id: clublink.id } })
    },
    create () {
      this.$router.push({ name: routes.create })
    },
    formatLink (clublink) {
      return `${FUNCTIONS_URL}/getClublink?id=${clublink.id}`
    }
  },
  created () {
    clipboard = new Clipboard('.copy-btn', {
      target: (trigger) => {
        return document.getElementById(trigger.getAttribute('clublink-id'))
      }
    })
    clipboard.on('success', (e) => {
      e.trigger.value = 'Copied !'
      e.trigger.classList.replace('is-info', 'is-success')
    })
    clipboard.on('error', (e) => {
      e.trigger.value = 'Ctrl+C to copy'
      e.trigger.classList.replace('is-info', 'is-danger')
    })
  },
  destroyed () {
    clipboard.destroy()
  }
}
</script>

<style>
.clublink-list {
  margin-bottom: 1em;
}
</style>
